export default {
  admin: 'Quản trị viên',
  password: {
    enterNewPassword: 'Nhập mật khẩu mới',
    reenterNewPassword: 'Nhập lại mật khẩu mới',
    updatePassword: 'Cập nhật mật khẩu',
    setPassword: 'Đặt mật khẩu',
    min8CharacterMessage: 'Mật khẩu phải có ít nhất 8 ký tự',
    passwordSentMessage: 'Mật khẩu đã được gửi đến {userName} qua email.',
    generateNewPassword: 'Tạo mật khẩu mới',
    assignPasswordMessage:
      'Gán mật khẩu cho người dùng. Người dùng sẽ được yêu cầu thay đổi mật khẩu này khi đăng nhập lần tới.',
    generateSecurePassword: 'Tạo mật khẩu an toàn',
    newPassword: 'Mật khẩu mới',
    confirmNewPassword: 'Xác nhận mật khẩu mới',
    passwordHistory: 'Lịch sử mật khẩu',
    passwordUpdatedLog: 'Mật khẩu được cập nhật bởi {userName} vào {date}.',
    forgotPasswordLog: 'Yêu cầu quên mật khẩu đã được gửi bởi {userName} vào {date}.',
  },
};
